export const enum Status {
  Active = "ACTIVE",
  Pending = "PENDING",
  Inactive = "INACTIVE",
  PendingReview = "PENDING_REVIEW",
  InReview = "IN_REVIEW",
}
